<template>
  <currency-form />
</template>

<script>
import CurrencyForm from '@/components/forms/CurrencyForm'
export default {
  components: {
    CurrencyForm
  }
}
</script>
